/**
 * Unified tape reading detection.
 * Returns true if the entry is a tape reading, regardless of which
 * field name was used (`isTapeReading` or `tapeReading`).
 */
export const isTapeReading = (e) => !!e.isTapeReading || !!e.tapeReading;
